import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IScrapeReportPayload } from '@app-store/slices/reporting/scrapeReport'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IScrapeReportPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.reporting.scrapeReport

function* scrapeReportSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/reporting/scrape-reporting`, {
            params: payload
        })
        if (response) {
            yield put(onSuccess(response.result.data))
            yield put(payload?.sagaCB?.onSuccess(response))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* scrapeReportSaga(): any {
    yield takeLatest<TaskAction>(onRequest, scrapeReportSagaTask)
}

export default scrapeReportSaga
